import { Button } from "primereact/button";
import React, { useEffect, useRef } from "react";
import { FaArrowLeft, FaArrowRight, FaPrint } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../Loader";
import { useTranslation } from "react-i18next";
import SharedButton from "../../components/Shared/SharedButton";

export default function ShowCompanyInvoice() {
  const { companyInvoiceCode } = useSelector((state) => state.invoice);
  const invoiceRef = useRef(null);
  const navigate = useNavigate();
  const iframeRef = useRef(null);

  useEffect(() => {
    if (invoiceRef.current && companyInvoiceCode) {
      invoiceRef.current.innerHTML = companyInvoiceCode;
    }
  }, [companyInvoiceCode]);
  const { isLoading } = useSelector((state) => state.invoice);

  const handlePrint = () => {
    const printContents = invoiceRef.current.innerHTML;
    const iframe = iframeRef.current;
    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write("<html><head><title>Invoice</title>");
    doc.write('<link rel="stylesheet" href="https://cdn.tailwindcss.com">');
    doc.write("</head><body>");
    doc.write(printContents);
    doc.write("</body></html>");
    doc.close();
    iframe.onload = () => {
      iframe.contentWindow.print();
    };
  };
  const { t , i18n} = useTranslation();
  const isRTL = i18n.language === "ar";
  return (
    <>
      <div>
        <div className="flex gap-3">

          <SharedButton
            label={t("Back")}
            icon={ isRTL ? <FaArrowRight /> : <FaArrowLeft />}
            onClick={() => navigate("/manager/insuranceInvoice")}
          />
          <SharedButton 
           label={t("PrintInvoice")}
            onClick={handlePrint}
            icon={<FaPrint />}
          />

        </div>

        <div id="print-invoice" ref={invoiceRef}></div>
        <iframe ref={iframeRef} style={{ display: "none" }}></iframe>
      </div>
      <Loader showLoader={isLoading} />
    </>
  );
}
